export default "__VITE_ASSET__BLIc2xdQ__";